/* eslint-disable react/jsx-no-duplicate-props */
/* eslint-disable no-unused-vars */
import React, {
  forwardRef,
  useImperativeHandle,
  useRef,
  useState,
} from 'react';
import apiService from '../../axios/apiService';
import PropTypes from 'prop-types';
import AssignRadiologistForm from './Forms/AssignRadiologist';
import { notification } from 'antd';

const AssignRadiologist = forwardRef(function AssignRadiologist(
  { onSuccess, onError, records },
  ref
) {
  const [api, contextHolder] = notification.useNotification();
  const formRef = useRef(null);
  const [loading, setLoading] = useState(false);

  useImperativeHandle(
    ref,
    () => ({
      reset: formRef?.current?.reset, // eslint-disable-line no-unused-labels
    }),
    []
  );

  const onSubmit = async (data) => {
    try {
      setLoading(true);
      let response;
      let description = 'Case assigned to radiologist successfully';
      if (records?.length === 1) {
        const record = records[0];
        response = await apiService.assignCaseToRadioLogist(record.caseId, {
          radioLogistUserSub: data.radioLogistUserSub,
          revenueAmount: data.revenueAmount,
        });
      } else {
        // Bulk assign cases to radiologist
        const caseIds = records.map((record) => record.caseId);
        response = await apiService.assignBulkCaseToRadioLogist(caseIds, {
          radioLogistUserSub: data.radioLogistUserSub,
          revenueAmount: data.revenueAmount,
        });
        description = 'Cases assigned to radiologist successfully';
      }
      api.success({
        message: 'Success',
        description,
      });
      setLoading(false);
      onSuccess?.(response);
    } catch (error) {
      api.error({
        description: error?.response?.data?.error || 'Error',
        message:
          error?.response?.data?.message ||
          'Error occured while assign case to Radiologist',
      });
      setLoading(false);
      onError?.(error);
    }
  };

  return (
    <>
      {contextHolder}
      <AssignRadiologistForm
        formValues={{}}
        onSubmit={onSubmit}
        loading={loading}
        ref={formRef}
      />
    </>
  );
});

AssignRadiologist.propTypes = {
  onSuccess: PropTypes.func,
  onError: PropTypes.func,
  records: PropTypes.array,
};

export default AssignRadiologist;
